import { Mail } from "lucide-react";

export const Footer = () => (
  <footer
    className="border-t border-edge/60"
    data-testid="footer"
  >
    <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-4 py-10 sm:flex-row sm:justify-between sm:px-6 lg:px-8">
      <img
        src="/assets/logo-180.png"
        alt="Truvon logo"
        className="h-9 w-9"
        data-testid="footer-logo"
      />
      <a
        href="mailto:hello@truvon.tech"
        data-testid="footer-contact-link"
        className="flex items-center gap-2 text-sm text-slate-500 transition-colors duration-200 hover:text-mint"
      >
        <Mail className="h-4 w-4" />
        hello@truvon.tech
      </a>
    </div>
  </footer>
);
